//src/config/apiConfig.js

// For Production Development
export const API_BASE_URL = "https://complaintsbackend.webddocsystems.com/api";
export const ChargingAPI_BASE_URL = "https://charging.webddocsystems.com/api";
export const WHSSubsAPI_BASE_URL = "https://webdocinsuranceportalapi.webddocsystems.com/";
export const JAZZ_WEBDOC_DETAILS_API_BASE_URL = process.env.REACT_APP_JAZZ_WEBDOC_DETAILS_API_BASE_URL || "https://complaintsbackend.webddocsystems.com/api/jazz";

export const UFONE_SUB_DETAILS_API_BASE_URL = process.env.REACT_APP_UFONE_SUB_DETAILS_API_BASE_URL || "/subDetails";
export const PROMOTION_API_BASE_URL = "https://digital.webdoc.com.pk/Promotion/public/api/v1/service";
export const TABEEB_API_BASE_URL = "https://erp.webdoc.com.pk/telenor.php";

// For Local Development
// export const API_BASE_URL = "http://localhost:3011/api";
// export const ChargingAPI_BASE_URL = "http://localhost:5000/api";

export const apiUrl = (path) => {
  if (!path) return [API_BASE_URL, ChargingAPI_BASE_URL , WHSSubsAPI_BASE_URL, PROMOTION_API_BASE_URL,TABEEB_API_BASE_URL];
  return `${API_BASE_URL}${path.startsWith("/") ? "" : "/"}${path}`;
};
